/* eslint-disable @typescript-eslint/no-restricted-imports */
import { AnyFunction, statsFunction } from '@fiverr-private/obs';

const PREFIX = 'services.tailored_homepage_perseus';

export const statsFunctionWrapper = <T extends AnyFunction>(
    func: T,
    name: string
): ReturnType<typeof statsFunction<T>> => statsFunction(func, `${PREFIX}.${name}`);
